import { render } from "./SettingMapping.vue?vue&type=template&id=b0fc61f8&scoped=true"
import script from "./SettingMapping.vue?vue&type=script&lang=js"
export * from "./SettingMapping.vue?vue&type=script&lang=js"

import "./SettingMapping.vue?vue&type=style&index=0&id=b0fc61f8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0fc61f8"]])

export default __exports__